module.exports = __webpack_public_path__ + "img/msg-right.876f15da.png";